<template>
  <div>
    <GridSyclus
      :idRecursoSistema="args.idRecursoSistema"
      title="Modelos Atividade"
      :headers="modeloAtividadeHeaders"
      :customHeaders="customHeaders"
      :items="modelosAtividade"
      item-key="IdModeloAtividade"
      :loading="loading"
      @aplicaFiltros="aplicaFiltros"
      @abreModalGridSyclus="abreModalGridSyclus"
      @changeLayoutSql="changeLayoutSql"
      @editItemSelected="editItemSelected"
      @deleteItemSelected="deleteItemSelected"
    />
    <ModalCadastroModeloAtividade 
      v-model="modalModeloAtividade"
      :modeloAtividade="modeloAtividade"
      :modeloAtividadeChecklist="modeloAtividadeChecklist"
      @modeloAtividadeAdicionado="modeloAtividadeAdicionado"
      @modeloAtividadeChecklistAdicionado="modeloAtividadeChecklistAdicionado"
      @editaChecklist="editaChecklist"
      @deleteChecklist=deleteChecklist
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import GridSyclus from '@/components/shared/GridSyclus';
import ModeloAtividade from '@/domain/modeloAtividade/ModeloAtividade';
import ModeloAtividadeChecklist from '@/domain/modeloAtividade/ModeloAtividadeChecklist';
import ModalCadastroModeloAtividade from '@/components/modeloAtividade/ModalCadastroModeloAtividade';
import { changePageTitle } from '../utils/changePageTitle';

export default {
  name: 'ModelosAtividadeView',
  components: {
    GridSyclus,
    ModalCadastroModeloAtividade
  },
  data() {
    return {
      args: {
        usuario: JSON.parse(localStorage.getItem('user')),
        idLayoutSql: null,
        colaboradores: [],
        status: ['P'],
        dataInicial: null,
        dataFinal: null,
        idRecursoSistema: 100019
      },
      modeloAtividadeHeaders: [
        { text: "ID", value: "IdModeloAtividade" },
        { text: "Descrição", value: "Descricao" },
        { text: "Status", value: "Status" },
      ],
      customHeaders: ["Status"],
      loading: false,
      modalModeloAtividade: false,
      modeloAtividade: new ModeloAtividade(),
      modeloAtividadeChecklist: new ModeloAtividadeChecklist(),
    }
  },
  computed: {
    ...mapGetters(['user', 'modelosAtividade']),
  },
  methods: {
    ...mapMutations(["showNotification", "closeNotification"]),
    ...mapActions([
      'resetaModeloAtividadeChecklists',
      'fetchModelosAtividadeSql',
      'fetchModeloAtividadeChecklists',
      'fetchLayoutsSqlUsuario',
      'deleteModeloAtividade',
      'deleteModeloAtividadeChecklist',
    ]),
    async aplicaFiltros() {
      this.loading = true;
      await this.fetchLayoutsSqlUsuario({ usuario: this.user, idRecursoSistema: 100019 });
      await this.fetchModelosAtividadeSql(this.args);
      this.loading = false;
    },
    changeLayoutSql(payload) {
      this.args.idLayoutSql = payload;
    },
    abreModalGridSyclus() {
      this.modalModeloAtividade = true;
      this.modeloAtividade = Object.assign({}, new ModeloAtividade());
      this.resetaModeloAtividadeChecklists();
    },
    async editItemSelected(payload) {
      if (payload && payload.IdModeloAtividade) {
        this.modeloAtividade = payload;
        await this.fetchModeloAtividadeChecklists(payload.IdModeloAtividade);
        this.modalModeloAtividade = true;
      } else if (payload.length) {
        this.modeloAtividade = payload[payload.length - 1];
        await this.fetchModeloAtividadeChecklists(payload.IdModeloAtividade);
        this.modalModeloAtividade = true;
      } else {
        this.showNotification({ text: "Selecione um modelo atividade para alterar.", status: 'error' });
      }
    },
    deleteItemSelected(payload) {
      if (payload.length) {
        if (confirm(`Tem certeza que deseja excluir: ${payload.length} registros?`)) {
          let promises = [];

          payload.forEach(item => {
            promises.push(this.deleteModeloAtividade(item.IdModeloAtividade));
          });
          Promise.all(promises)
            .then(() => {
              this.showNotification({ text: `Operação concluída com sucesso.`, status: 'success' });
            })
            .catch(error => {
              this.loading = false;
              console.log(error);
              this.showNotification({ text: `Ocorreu um erro ao excluir os modelos atividade: ${error}`, status: 'error' });
            });
        } else {
          this.showNotification({ text: `Operação cancelada.`, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Selecione pelo menos um modelo atividade para excluir.', status: 'error' });
      }
    },
    modeloAtividadeAdicionado() {
      this.modeloAtividade = Object.assign({}, new ModeloAtividade());
    },
    editaChecklist(checklist) {
      this.modeloAtividadeChecklist = Object.assign({}, checklist);
    },
    async deleteChecklist(checklist) {
      if (confirm(`Desejar remover o checklist: ${checklist.Descricao}?`)) {
        this.loading = true;
        try {
          await this.deleteModeloAtividadeChecklist(checklist);
          this.loading = false;
          this.modeloAtividadeChecklistAdicionado = Object.assign({}, new ModeloAtividadeChecklist());
          this.showNotification({ text: 'Checklist excluído com sucesso.', status: 'success' });
        } catch (error) {
          this.loading = false;
          console.log(error);
          this.showNotification({ text: `Ocorreu um erro ao excluir o checklist: ${error}`, status: 'error' });
        }
      } else {
        this.showNotification({ text: `Operação cancelada.`, status: 'error' });
      }
    },
    modeloAtividadeChecklistAdicionado() {
      this.modeloAtividadeChecklist = Object.assign({}, new ModeloAtividadeChecklist());
    }
  },
  created() {
    changePageTitle('Modelos Atividade');
  }
}
</script>

<style>

</style>